
            const data = {"name":"glyph/24/arrow-left-lightblue","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M17 23.414 6.293 12.707a.999.999 0 0 1 0-1.414L17 .586 18.414 2l-10 10 10 10L17 23.414z\" class=\"nc-icon-wrapper\" _fill=\"#0073e6\"/>","originalColors":[{"type":"fill","color":"#0073e6"}],"stopColors":[]}}
        
                    module.exports = data
                    